import React, { Component } from "react";
import ReactHighcharts from "react-highcharts";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import moment from "moment";
import classnames from "classnames";
import PropTypes from "prop-types";
import { investmentPropType, valuationProptype } from "PropTypes";
import { isEqual } from "lodash";
import { getText } from "TermsMapper";
import {
  getDataForGraph,
  parseData,
  formatMoneyLabel,
  globalChartConfig,
  greenAreaSeries,
  yAxisChart,
  labelsYAxis,
  xAxisChart,
  labelsXAxis,
  tooltipChart,
  plotOptionsChart,
} from "lib/charts/historyChartConfig";
import { perUnitNumberPrecision } from "config/priceInput";
import formatDate from "lib/formatDate";
import { showMarketValue } from "./config";
import isValidNumberInput from "lib/formatters/isValidNumberInput";
import { formatPriceInputPreview } from "lib/abbreviatedFormat";

function valuationDataMapper(
  {
    created_at,
    amount,
    price_per_unit: pricePerUnit,
    historical: historical,
    date: date,
    id,
  },
  investment,
) {
  return {
    y: +amount,
    created_at: created_at,
    date: date,
    historical: historical,
    pricePerUnit: +pricePerUnit,
    id: id,
    investment,
  };
}

class ValuationHistoryChart extends Component {
  componentDidMount() {
    NoDataToDisplay(ReactHighcharts.Highcharts);
  }

  shouldComponentUpdate(nextProps) {
    if (
      this.props.collection &&
      !isEqual(this.props.collection, nextProps.collection)
    ) {
      return true;
    }
    return false;
  }

  renderHTMLValuationsTooltip() {
    const hasQuantity = !!this.investment.quantity;
    const tooltipClassnames = classnames("HistoryChartTooltip", {
      hide: this.id === null,
      hasQuantity: hasQuantity,
    });
    const investmentType = `per ${getText(
      this.investment.type,
      "valuation_unit",
    )}`;
    const PricePerUnit = isValidNumberInput(this.pricePerUnit)
      ? formatPriceInputPreview(this.pricePerUnit, {
          precision: perUnitNumberPrecision,
        })
      : "";
    return `
    <div class="${tooltipClassnames}">
      <div class="HistoryChartTooltip-date">
        ${formatDate(this.date, "ll")}
      </div>
      <span class="HistoryChartTooltip-amount">
      ${showMarketValue(
        this.y,
        this.historical,
        this.pricePerUnit,
        this.unit_count,
        this.investment,
      )}
      </span>
      ${
        hasQuantity
          ? `
        <div class="HistoryChartTooltip-content">
          <span class="HistoryChartTooltip-marketValue">${PricePerUnit}</span>
          ${investmentType}
        </div>
        `
          : ""
      }
    </div>`;
  }

  render() {
    const { collection, investment } = this.props;
    const currentCollection = collection.length > 1 ? collection : [];
    const reversedValuations = currentCollection.slice().reverse();
    const dates = getDataForGraph(reversedValuations, "date");
    const valuationsPoints = parseData(reversedValuations, (point) =>
      valuationDataMapper(point, investment),
    );
    const totalValuationAmount =
      currentCollection.length > 0 && currentCollection[0].amount;

    const config = {
      ...globalChartConfig,
      tooltip: {
        ...tooltipChart,
      },
      plotOptions: {
        ...plotOptionsChart,
      },
      series: [
        {
          ...greenAreaSeries,
          name: "Valuation",
          type: "area",
          data: valuationsPoints,
          tooltip: {
            pointFormatter: this.renderHTMLValuationsTooltip,
          },
        },
      ],
      xAxis: {
        ...xAxisChart,
        type: "datetime",
        labels: {
          ...labelsXAxis,
          formatter: function () {
            return moment(this.value).format("MM/DD");
          },
        },
        categories: dates,
      },
      yAxis: {
        ...yAxisChart,
        labels: {
          ...labelsYAxis,
          formatter: function () {
            return formatMoneyLabel(this.value);
          },
        },
      },
    };

    return (
      <div className="ValuationHistoryChart HistoryChart">
        <div className="ChartLabels">
          <div className="ChartLabels-content">
            Current Valuation:{" "}
            <span className="ChartLabels-amount">
              {formatPriceInputPreview(totalValuationAmount)}
            </span>
          </div>
        </div>
        <ReactHighcharts config={config} />
      </div>
    );
  }
}

ValuationHistoryChart.propTypes = {
  collection: PropTypes.arrayOf(valuationProptype),
  investment: investmentPropType,
};

export default ValuationHistoryChart;
